import styled, { keyframes } from "styled-components"
import ModalLayout from "./common/ModalLayout"
import MainButton from "../atoms/MainButton"
import MicRoundedIcon from '@mui/icons-material/MicRounded';
import Text from "../atoms/Text";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  position: relative;
`
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const MicWrapper = styled.div`
  position: relative;
  width: 72px;
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
`;
const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.6;
  }
  70% {
    transform: scale(2);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
`;
const Pulse = styled.div`
  pointer-events: none;
  position: absolute;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background-color: rgba(102, 255, 102, 0.5);
  animation: ${pulse} 2s ease-out infinite;
  z-index: 1;

  &:nth-child(1) {
    animation-delay: 0s;
  }
  &:nth-child(2) {
    animation-delay: 0.4s;
  }
`;
const mic = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
`;
const Mic = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: ${({ $status, theme }) => $status === "error" ? `5px solid ${theme.colors.status.error}` : "none"};
  outline-offset: 4px; 
  background-color: ${({ theme, $status }) => 
    $status === "error" ? theme.colors.neutral[200] : theme.colors.secondary};
  z-index: 2;
  animation: ${({ $status }) => $status === "Listening" ? `${mic} 2s ease-in-out infinite` : "none"};
`
const MicIcon = styled(MicRoundedIcon)`
  color: ${({ theme, $status }) => $status === "error" ? theme.colors.text.normal : theme.colors.text.inverse};
`
const ButtonWrapper= styled.div`
  margin-top: 20px;
`
const LoadingDots = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  margin-top: 8px;

  div {
    width: 12px;
    height: 12px;
    background-color: ${(props) => props.theme.colors.secondary};
    border-radius: 50%;
    animation: ${keyframes`
      0%, 80%, 100% { transform: scale(0); }
      40% { transform: scale(1); }
    `} 1.4s infinite ease-in-out;
  }

  div:nth-child(1) { animation-delay: 0s; }
  div:nth-child(2) { animation-delay: 0.2s; }
  div:nth-child(3) { animation-delay: 0.4s; }
`;
const CloseIcon = styled(CloseRoundedIcon)`
  color: ${(props) => props.theme.colors.text.normal};
`
const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
`

const RecordVoiceModal = ({status, onRetry, onCancel}) => {
  return (
    <ModalLayout>
      <Wrapper>
        <CloseButton onClick={onCancel}>
          <CloseIcon/>
        </CloseButton>
        <MicWrapper>
          {status === "listening" && (
              <>
                <Pulse />
                <Pulse />
              </>
            )}
          {status !== "processing" && (
            <Mic $status={status}>
              <MicIcon $status={status} sx={{ fontSize: 36 }} />
            </Mic>
          )}
          {status === "processing" && (
            <LoadingDots>
              <div></div>
              <div></div>
              <div></div>
            </LoadingDots>
          )}
        </MicWrapper>
        <TextWrapper>
          {status === "recording" && <Text variant="body2" weight="medium">지금 말씀해 주세요.</Text>}
          {status === "listening" && <Text variant="body2" weight="medium">음성 인식 중입니다.</Text>}
          {status === "processing" && <Text variant="body2" weight="medium">저장 중입니다.</Text>}
          {status === "error" && 
            <>
              <Text variant="body2" weight="medium">다시 시도해주세요.</Text>
              <ButtonWrapper>
                <MainButton
                  $variant="primary"
                  $size="small"
                  title="다시하기"
                  onClick={onRetry}/> 
              </ButtonWrapper>
            </>
          }
        </TextWrapper>
      </Wrapper>
    </ModalLayout>
  )
}

export default RecordVoiceModal
